import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { IconNoActivity } from '@contrast-security-inc/design-system-foundations'
import { Link } from '@contrast-security-inc/design-system-typography'
import { InformationPanel } from '@contrast-security-inc/design-system-surfaces'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { formatStyles } from '../react-intl-helpers'

export const AttackEmptyState = () => {
  const intl = useIntl()

  return (
    <Stack>
      <InformationPanel
        className={css`
          width: 100%;
          height: fit-content;
          border: none;
          box-shadow: none;
        `}
        Icon={IconNoActivity}
        IconProps={{
          testId: 'information-panel-icon'
        }}
        title={intl.formatMessage({
          id: 'detail_protectFeatures_noAttacks'
        })}
        subtitle={intl.formatMessage(
          { id: 'detail_protectFeatures_attackDataPolicy' },
          {
            a: (msg) => (
              <Link
                href="https://docs.contrastsecurity.com/en/attacks.html"
                isExternal
              >
                {msg}
              </Link>
            )
          }
        )}
        detail={intl.formatMessage(
          { id: 'detail_protectFeatures_restartServer' },
          { ...formatStyles.bold }
        )}
      />
    </Stack>
  )
}
